import * as React from "react"
import {
  Stack,
} from '@chakra-ui/react';
import ContactForm from "./ContactForm";

export default function ContactUs() {

  return (
    <Stack direction={'row'} alignItems='center' justify='center'>
      <ContactForm></ContactForm>
    </Stack>
  );
}